import React from 'react'

const HeroBanner = () => {
  return (
    <div className=" w-full grid grid-cols-1 md:grid-cols-2 gap-16  items-center ">
      {/* coulumn 1 */}
      <div className=" flex flex-col gap-4 items-start  ">
        <h1 className=" h1 ">Flexible and scalable engagement platform</h1>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Bettermode is customizable, scalable, and secure. It’s a platform trusted by community-led
          businesses. And Bettermode is here to help you.
        </p>

        <div className=" flex  flex-col  mt-2 md:mt-4">
          <button className=" btn_primary  !py-4 !px-7 !rounded-full">Book a Demo</button>
        </div>
      </div>
      {/* column 2 */}
      <div className=" w-full  h-full ">
        <img
          src="https://media.tradly.app/images/marketplace/99874/636358a162f1de7c2d7bc417_feature-index-06-p-1080-KiMlI9Yc.webp"
          loading="lazy"
          width="1623"
          sizes="(max-width: 479px) 100vw, (max-width: 767px) 96vw, (max-width: 991px) 94vw, 1072px"
          alt="MacBook mockup"
          className=" w-full h-full      object-contain"
        />
      </div>
    </div>
  )
}

export default HeroBanner
